import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    height: 100%;
  }

  .layout {
    box-sizing: border-box;
    display: grid;
    height: 100%;
    grid-template-rows: auto 1fr auto;
    gap: 6rem;
    padding: 2rem 1rem;
    background: var(--sds-color-background-default-default);
    border-right: 1px solid var(--sds-color-border-default-default);
    transition: background-color 0.2s ease;
  }

  .logo {
    width: fit-content;
    height: 1.5rem;
    display: block;
    padding: 0 1rem;
  }

  @media (max-width: 768px) {
    .logo {
      display: none;
    }
  }

  .menu-list-desktop {
    display: grid;
    gap: 1.5rem;
    overflow: auto;
  }

  .menu-list-mobile {
    display: none;
  }

  .menu-section {
    display: grid;
    gap: 0.5rem;
    height: fit-content;
  }

  .menu-item {
    flex: 1;
    display: flex;
    font-weight: var(--sds-typography-weight-semibold);
    align-items: center;
    font-size: 0.875rem;
    gap: 0.75rem;
    padding: 0.75rem;
    cursor: pointer;
    text-decoration: none;
    color: var(--sds-color-text-default-tertiary);

    &.active {
      color: var(--sds-color-text-default-default);
      background-color: var(--sds-color-background-default-secondary-hover);
    }

    .icon {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .bottom-section {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .toggle-selections {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: var(--sds-size-space-150);
  }

  .language-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .language-button {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid var(--sds-color-border-default-default);
    background: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    overflow: hidden;
    box-sizing: border-box;
  }

  .language-button.active {
    border-color: var(--sds-color-border-neutral-default);
  }

  .language-button:hover {
    background: var(--sds-color-background-default-default-hover);
  }

  .theme-toggles {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    align-items: center;
  }

  .theme-toggle {
    width: 24px;
    height: 24px;
    border: 2px solid var(--sds-color-border-default-default);
    border-radius: 50%;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: none;
    color: var(--sds-color-text-default-tertiary);
    transition: 0.2s;

    &.active {
      color: var(--sds-color-text-default-default);
      border-color: var(--sds-color-border-neutral-default);
    }

    .icon {
      width: 12px;
      height: 12px;
    }
  }

  @media (max-width: 768px) {
    .layout {
      padding: 0;
      display: flex;
      border-top: 1px solid var(--sds-color-border-default-default);
    }

    .menu-list-desktop {
      display: none;
    }

    .menu-list-mobile {
      display: flex;
      justify-content: space-around;
      width: 100%;
      align-items: center;
    }

    .menu-item {
      flex-direction: column;
      text-align: center;
      gap: 0.25rem;
      padding: 2px 0.75rem;
      height: 100%;
      box-sizing: border-box;
      line-height: 1.2;
      justify-content: center;

      .icon {
        width: 24px;
        height: 24px;
      }
    }

    .bottom-section {
      display: none;
    }
  }
`;
